import '.a2{font-family:FunnelDisplay;}.ssr-plugin'
import '.d7{font-weight:700;}.ssr-plugin'
import '.c8{margin-top:0px;}.ssr-plugin'
import '.ds{margin-bottom:1.5rem;}.ssr-plugin'
import useMediaQuery from '@app/util/useMediaQuery'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

export interface QuoteProps extends PropsWithChildren {
  style?: Style
}

export const Quote = ({ children, style }: QuoteProps) => {
  const isMobile = useMediaQuery()

  return (
    <styled.blockquote className="a2 d7 c8 ds"
      style={{
        fontSize: isMobile ? '2rem' : '3rem',
        lineHeight: isMobile ? '130%' : '100%',
        ...style,
      }}
    >
      “{children}”
    </styled.blockquote>
  )
}
